import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AccountService } from '@app/services/account.service';
import { ValidatedInputComponent } from '@app/ui-components/validated-input/validated-input.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-registration',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    ValidatedInputComponent,
  ],
  templateUrl: './registration.component.html',
  styleUrl: './registration.component.scss',
})
export class RegistrationComponent {
  registerForm: FormGroup;
  errorMessage: string = '';
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private accountService: AccountService,
    private router: Router
  ) {
    this.registerForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  ngOnInit(): void {}

  get email() {
    return this.registerForm.get('email');
  }

  get password() {
    return this.registerForm.get('password');
  }

  onSubmit(): void {
    if (this.registerForm.invalid) {
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    const credentials = {
      email: this.email?.value,
      password: this.password?.value,
    };

    this.accountService.register(credentials).subscribe({
      next: (response) => {
        this.loading = false;
        if (response.success) {
          this.router.navigate(['/auth/login']);
        } else if (response.message == 'Messages.MailUsed') {
          this.email?.setErrors({ mailUsed: 'mailUsed' });
          this.email?.markAsTouched();
        }
      },
      error: (response) => {
        this.loading = false;
        if (response.error.message == 'Messages.MailUsed') {
          this.email?.setErrors({ mailUsed: 'mailUsed' });
          this.email?.markAsTouched();
        } else {
          this.errorMessage =
            response.error?.message ||
            'Login failed. Please check your credentials.';
        }
      },
    });
  }
}
